.wrapper {
  z-index: 1; /* for picker menu to appear above visualization */
  display: flex;
  padding: 0 0.5rem;
  font-size: 0.875rem;
}

.inner {
  padding: 0.25rem 0;
}

.allAuxOption {
  color: var(--h5w-selector-groupLabel--color, gray);
  text-transform: uppercase;
  font-size: 0.75em;
  font-weight: 600;
  line-height: 1.6;
}
